module.exports = __webpack_public_path__ + "static/img/股权架构.1f42de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/股权架构.png
// module id = yWe6
// module chunks = 1